/* IKO TCG – Apple-stijl interacties (navigatie, zoeken, carrousels, animaties) */
(function () {
  'use strict';

  var d = document;
  var root = d.documentElement;
  var mqDesk = window.matchMedia('(min-width: 1024px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var design = !!(window.Shopify && window.Shopify.designMode);

  function onMq(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- 1. Titels opschonen ("." en "!" voor productnamen) ---------- */
  var TITLE_SEL = [
    '.card__heading a',
    '.card__heading',
    '.predictive-search__item-heading',
    '.cart-item__name',
    '.cart-notification-product__name',
    '.quick-add-modal .product__title h2',
    '.breadcrumbs a'
  ].join(',');

  function cleanText(s) {
    return String(s || '').replace(/^(\s*)[.!]+\s*/, '$1');
  }

  function cleanTitles(scope) {
    var els = (scope || d).querySelectorAll(TITLE_SEL);
    for (var i = 0; i < els.length; i++) {
      var nodes = els[i].childNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 3 && /^\s*[.!]/.test(n.nodeValue)) n.nodeValue = cleanText(n.nodeValue);
      }
    }
  }

  function cleanDocTitle() {
    if (/^\s*[.!]/.test(d.title)) d.title = cleanText(d.title).trim();
  }

  /* ---------- 2. Animatie bij scrollen ---------- */
  var io = null;
  function initReveal(scope) {
    var els = (scope || d).querySelectorAll('.ik-reveal:not(.is-in)');
    if (!els.length) return;
    if (design || reduce.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  /* ---------- 3. Navigatie ---------- */
  function lock(on) {
    root.classList.toggle('ik-lock', !!on);
  }

  function initNav(scope) {
    var gn = (scope || d).querySelector('[data-ik-gn]');
    if (!gn || gn.dataset.ready) return;
    gn.dataset.ready = '1';

    var wrap = gn.parentElement;
    var curtain = wrap ? wrap.querySelector('[data-ik-curtain]') : null;
    var items = gn.querySelectorAll('.ik-gn__item.has-flyout');
    var panels = gn.querySelectorAll('[data-flyout-panel]');
    var search = gn.querySelector('[data-ik-search]');
    var input = search ? search.querySelector('[data-ik-search-input]') : null;
    var results = search ? search.querySelector('[data-ik-search-results]') : null;
    var quick = search ? search.querySelector('[data-ik-search-quick]') : null;
    var burger = gn.querySelector('[data-ik-menu-toggle]');
    var mnav = gn.querySelector('[data-ik-mnav]');
    var openId = null;
    var tOpen = null;
    var tClose = null;

    function setCurtain(on) {
      if (curtain) curtain.classList.toggle('is-on', !!on);
    }

    function openFly(id) {
      clearTimeout(tClose);
      if (openId === id) return;
      closeSearch(true);
      for (var i = 0; i < panels.length; i++) {
        var on = panels[i].id === id;
        panels[i].classList.toggle('is-open', on);
        panels[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      for (var j = 0; j < items.length; j++) {
        var active = items[j].getAttribute('data-flyout') === id;
        items[j].classList.toggle('is-active', active);
        var t = items[j].querySelector('[data-ik-fly-toggle]');
        if (t) t.setAttribute('aria-expanded', active ? 'true' : 'false');
      }
      openId = id;
      gn.classList.add('has-open');
      setCurtain(true);
    }

    function closeFly() {
      clearTimeout(tOpen);
      if (!openId) return;
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.remove('is-open');
        panels[i].setAttribute('aria-hidden', 'true');
      }
      for (var j = 0; j < items.length; j++) {
        items[j].classList.remove('is-active');
        var t = items[j].querySelector('[data-ik-fly-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      openId = null;
      gn.classList.remove('has-open');
      if (!gn.classList.contains('is-searching')) setCurtain(false);
    }

    Array.prototype.forEach.call(items, function (it) {
      var id = it.getAttribute('data-flyout');
      it.addEventListener('mouseenter', function () {
        if (!mqDesk.matches || gn.classList.contains('is-searching')) return;
        clearTimeout(tOpen);
        clearTimeout(tClose);
        tOpen = setTimeout(function () { openFly(id); }, openId ? 0 : 140);
      });
      it.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
      var toggle = it.querySelector('[data-ik-fly-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          if (openId === id) closeFly();
          else openFly(id);
        });
      }
    });

    Array.prototype.forEach.call(gn.querySelectorAll('.ik-gn__item:not(.has-flyout), .ik-gn__logo, .ik-gn__actions'), function (el) {
      el.addEventListener('mouseenter', function () {
        if (!mqDesk.matches) return;
        clearTimeout(tOpen);
        tClose = setTimeout(closeFly, 160);
      });
    });

    gn.addEventListener('mouseleave', function () {
      clearTimeout(tOpen);
      tClose = setTimeout(closeFly, 200);
    });
    gn.addEventListener('mouseenter', function () { clearTimeout(tClose); });

    /* Zoeken */
    var ctrl = null;
    var tq = null;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function money(v) {
      var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
      if (isNaN(n)) return '';
      if (typeof v === 'number' && Number.isInteger(v) && n > 999) n = n / 100;
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(n);
      } catch (e) {
        return '€ ' + n.toFixed(2).replace('.', ',');
      }
    }

    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function renderResults(r, q) {
      var prods = (r && r.products) || [];
      var cols = (r && r.collections) || [];
      if (!prods.length && !cols.length) {
        results.innerHTML = '<p class="ik-search__empty">Geen resultaten voor “' + esc(q) + '”.</p>';
        if (quick) quick.hidden = false;
        return;
      }
      var h = '';
      if (prods.length) {
        h += '<p class="ik-fly__label">Producten</p><ul class="ik-search__list" role="list">';
        prods.forEach(function (p) {
          var src = (p.featured_image && p.featured_image.url) || p.image || '';
          var img = src ? '<img src="' + esc(sized(src, 120)) + '" alt="" width="48" height="48" loading="lazy">' : '';
          var price = p.price != null ? money(p.price) : '';
          h += '<li><a class="ik-search__hit" href="' + esc(p.url) + '"><span class="ik-search__thumb">' + img + '</span>' +
            '<span class="ik-search__name">' + esc(cleanText(p.title)) + '</span>' +
            '<span class="ik-search__price">' + esc(p.available === false ? 'Uitverkocht' : price) + '</span></a></li>';
        });
        h += '</ul>';
      }
      if (cols.length) {
        h += '<p class="ik-fly__label">Collecties</p><ul class="ik-search__list" role="list">';
        cols.forEach(function (c) {
          h += '<li><a class="ik-search__hit ik-search__hit--col" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        });
        h += '</ul>';
      }
      h += '<a class="ik-link ik-search__all" href="' + esc(base) + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Alle resultaten voor “' + esc(q) + '” ›</a>';
      results.innerHTML = h;
      if (quick) quick.hidden = true;
    }

    function query(q) {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          renderResults(data && data.resources && data.resources.results, q);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          results.innerHTML = '';
          if (quick) quick.hidden = false;
        });
    }

    function openSearch() {
      if (!search) return;
      closeFly();
      closeMenu(true);
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      gn.classList.add('is-searching');
      setCurtain(true);
      if (!mqDesk.matches) lock(true);
      setTimeout(function () { if (input) input.focus(); }, 60);
    }

    function closeSearch(silent) {
      if (!search || !gn.classList.contains('is-searching')) return;
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      gn.classList.remove('is-searching');
      if (!openId) setCurtain(false);
      lock(false);
      if (!silent) {
        var opener = gn.querySelector('[data-ik-search-open]');
        if (opener) opener.focus();
      }
    }

    Array.prototype.forEach.call(gn.querySelectorAll('[data-ik-search-open]'), function (b) {
      b.addEventListener('click', function () {
        if (gn.classList.contains('is-searching')) closeSearch();
        else openSearch();
      });
    });
    if (search) {
      var closeBtn = search.querySelector('[data-ik-search-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeSearch(); });
    }
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(tq);
        var q = input.value.trim();
        if (q.length < 2) {
          if (ctrl && ctrl.abort) ctrl.abort();
          results.innerHTML = '';
          if (quick) quick.hidden = false;
          return;
        }
        tq = setTimeout(function () { query(q); }, 180);
      });
    }

    /* Mobiel menu */
    function resetSub() {
      if (!mnav) return;
      mnav.classList.remove('in-sub');
      Array.prototype.forEach.call(mnav.querySelectorAll('.ik-mnav__panel.is-sub'), function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
      });
    }

    function openMenu() {
      if (!mnav) return;
      closeSearch(true);
      mnav.classList.add('is-open');
      mnav.setAttribute('aria-hidden', 'false');
      gn.classList.add('menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      lock(true);
    }

    function closeMenu(silent) {
      if (!mnav || !mnav.classList.contains('is-open')) return;
      mnav.classList.remove('is-open');
      mnav.setAttribute('aria-hidden', 'true');
      gn.classList.remove('menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      lock(false);
      setTimeout(resetSub, 300);
      if (!silent && burger) burger.focus();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (mnav && mnav.classList.contains('is-open')) closeMenu();
        else openMenu();
      });
    }
    if (mnav) {
      Array.prototype.forEach.call(mnav.querySelectorAll('[data-ik-sub]'), function (b) {
        b.addEventListener('click', function () {
          var p = d.getElementById(b.getAttribute('data-ik-sub'));
          if (!p) return;
          p.hidden = false;
          mnav.classList.add('in-sub');
          mnav.scrollTop = 0;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { p.classList.add('is-active'); });
          });
        });
      });
      Array.prototype.forEach.call(mnav.querySelectorAll('[data-ik-back]'), function (b) {
        b.addEventListener('click', resetSub);
      });
    }

    if (curtain) {
      curtain.addEventListener('click', function () {
        closeFly();
        closeSearch(true);
      });
    }

    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (gn.classList.contains('is-searching')) closeSearch();
      else if (mnav && mnav.classList.contains('is-open')) closeMenu();
      else closeFly();
    });

    onMq(mqDesk, function () {
      closeFly();
      closeMenu(true);
      closeSearch(true);
    });

    /* Status bij scrollen + hoogte voor andere onderdelen */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        gn.classList.toggle('is-scrolled', (window.pageYOffset || root.scrollTop) > 2);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    function setHeights() {
      var h = gn.querySelector('.ik-gn__bar');
      if (h) {
        root.style.setProperty('--header-height', h.offsetHeight + 'px');
        root.style.setProperty('--header-bottom-position-desktop', h.offsetHeight + 'px');
      }
    }
    setHeights();
    window.addEventListener('resize', setHeights);
  }

  /* ---------- 4. Carrousels ---------- */
  function initCarousels(scope) {
    var wraps = (scope || d).querySelectorAll('[data-ik-carousel]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var track = wrap.querySelector('[data-ik-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-ik-prev]');
      var next = wrap.querySelector('[data-ik-next]');

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        var w = first.getBoundingClientRect().width + gap;
        var per = Math.max(1, Math.floor((track.clientWidth - 40) / w));
        return w * per;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        wrap.classList.toggle('is-static', max <= 2);
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; update(); });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 600);
    });
  }

  /* ---------- 5. Veelgestelde vragen ---------- */
  function initFaq(scope) {
    var items = (scope || d).querySelectorAll('.ik-faq__item');
    Array.prototype.forEach.call(items, function (det) {
      if (det.dataset.ready) return;
      det.dataset.ready = '1';
      var sum = det.querySelector('summary');
      var body = det.querySelector('.ik-faq__a');
      if (!sum || !body) return;
      if (det.open) det.classList.add('is-open');
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (det.dataset.busy) return;
        if (reduce.matches) {
          det.open = !det.open;
          det.classList.toggle('is-open', det.open);
          return;
        }
        det.dataset.busy = '1';
        var done = function () {
          body.style.height = '';
          delete det.dataset.busy;
        };
        if (det.open) {
          body.style.height = body.scrollHeight + 'px';
          det.classList.remove('is-open');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { body.style.height = '0px'; });
          });
          setTimeout(function () { det.open = false; done(); }, 400);
        } else {
          det.open = true;
          det.classList.add('is-open');
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { body.style.height = h + 'px'; });
          });
          setTimeout(done, 400);
        }
      });
    });
  }

  /* ---------- Start ---------- */
  function initAll(scope) {
    initNav(scope);
    initReveal(scope);
    initCarousels(scope);
    initFaq(scope);
    cleanTitles(scope);
  }

  initAll(d);
  cleanDocTitle();
  window.IKO_READY = true;

  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        cleanTitles(d);
      });
    }).observe(d.body, { childList: true, subtree: true });
  }

  d.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
